import { makeSprite } from "html-living-framework/lib/Utils/PixiUtils";
import * as Topics from "Data/Topics";
import { Sine, TimelineMax } from "gsap";
import { PixiUtils, PointUtils } from "html-living-framework";
import { changeParent } from "Utils/layoutUtils";

export default class TutorialHand extends PIXI.Container {

    upSprite = this.addChild(makeSprite("tutorial-hand-up"));
    downSprite = this.addChild(makeSprite("tutorial-hand-down"));
    protected _subscriptions: any[] = [];
    protected _hintTimeline?: TimelineMax;

    constructor() {
        super();
        this.downSprite.scale.set(0.35);
        this.upSprite.scale.set(0.35);
        this.upSprite.position.set(this.upSprite.width/2, this.upSprite.height/2);
        this.downSprite.position.copyFrom(this.upSprite.position);
        this.upSprite.visible = true;
        this.downSprite.visible = false;
        this._subscriptions.push(
            PubSub.subscribe(Topics.SHOW_HINT, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.HIDE_HINT, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.HIDE_ALL_HINTS, this.onMessageReceived.bind(this)),
        );
        this.visible = false;
    }

    public destroy(pDestroyOptions?: any) {
        super.destroy(pDestroyOptions);
        this._subscriptions.forEach(PubSub.unsubscribe);
        this._hintTimeline?.kill();
    }

    protected showHint(
        target: PIXI.Container | PIXI.Point | PIXI.IPointData,
        delay: number = 0,
    ) {
        this.visible = true;
        this.downSprite.visible = false;
        this.upSprite.visible = false;
        PixiUtils.sendToFront(this);

        if (target instanceof PIXI.Container) {
            this.position.copyFrom(this.parent.toLocal(target.getGlobalPosition()));
        }
        else if (target instanceof PIXI.Point) {
            this.position.copyFrom(this.parent.toLocal(target));
        }
        else if (!!target.x && !!target.y) {
            this.position.copyFrom(target);
        }

        if (this._hintTimeline !== undefined) {
            this._hintTimeline.kill();
            this._hintTimeline.delay(delay);
            this._hintTimeline.restart(true);
        }
        else {
            this._hintTimeline = new TimelineMax();
            this._hintTimeline.repeat(-1);
            this._hintTimeline.call(()=>{
                this.downSprite.visible = false;
                this.upSprite.visible = true;
            }, undefined, undefined, 0);
            this._hintTimeline.call(()=>{
                this.downSprite.visible = true;
                this.upSprite.visible = false;
            }, undefined, undefined, 0.5);
            this._hintTimeline.call(()=>{
                this.downSprite.visible = false;
                this.upSprite.visible = true;
            }, undefined, undefined, 1);

            this._hintTimeline.delay(delay);
        }
    }

    protected hideHint() {
        this.visible = false;
        this._hintTimeline?.kill();
    }

    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case Topics.SHOW_HINT:
                if (pData.type === "hand") {
                    this.showHint(pData.target, pData.delay);
                    break;
                }
                // else fallthrough
            case Topics.HIDE_HINT:
            case Topics.HIDE_ALL_HINTS:
                this.hideHint();
                break;
        }
    }
}